var _style, _circle, _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAvoidanceBlocked(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "\\u5716\\u5C64_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 12 12",
    style: {
      enableBackground: "new 0 0 12 12"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t\t.AvoidanceBlocked-st0 {\r\n\t\t\tfill: currentColor\r\n\t\t}\r\n\r\n\t\t.AvoidanceBlocked-st1 {\r\n\t\t\tfill: currentColor;\r\n\t\t}\r\n\t")), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "AvoidanceBlocked-st0",
    cx: 6,
    cy: 6,
    r: 1.6
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "AvoidanceBlocked-st1",
    d: "M6,12c-1.5,0-3.1-0.6-4.3-1.8l0.7-0.7c1.9,1.9,5.1,1.9,7,0l0.7,0.7C9.1,11.4,7.5,12,6,12z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "AvoidanceBlocked-st1",
    d: "M2.5,2.5L1.8,1.8c2.3-2.3,6.2-2.3,8.5,0L9.5,2.5C7.6,0.6,4.4,0.6,2.5,2.5z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "AvoidanceBlocked-st1",
    d: "M6,9.8c-1,0-2-0.4-2.7-1.1L4,8C5.1,9.1,6.9,9.1,8,8l0.7,0.7C8,9.5,7,9.8,6,9.8z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "AvoidanceBlocked-st1",
    d: "M8,4C7.4,3.5,6.7,3.2,6,3.2S4.6,3.5,4,4L3.3,3.3C4,2.6,5,2.2,6,2.2l0,0c1,0,2,0.4,2.7,1.1L8,4z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAvoidanceBlocked);
export default __webpack_public_path__ + "static/media/AvoidanceBlocked.458ecc37da8cd4937721c593e05d39f1.svg";
export { ForwardRef as ReactComponent };